import { Button, InputLabel, Tooltip } from "@material-ui/core";
import { Delete, Visibility } from "@material-ui/icons";
import { buttonsStyle } from "./tables/table";

import { SERVER_URL } from "../../api";
import PreviewDialog from "./dialogs/PreviewDialog";

export default function UploadDocument({ labelTitle = "Document", objectClass, setObjectClass, openFileDialog, setOpenFileDialog }) {

    return (
        <div className="mt-2">
            <InputLabel>{labelTitle}</InputLabel>
            <label htmlFor={"upload-documents"} className="ml-0 mb-4 mt-1" >
                <input
                    style={{ display: "none" }}
                    id={"upload-documents"}
                    name={"upload-documents"}
                    type="file"
                    accept=".pdf,application/pdf,.mp4,.png,.jpg"
                    onChange={(e) => {
                        const file = e.target.files[0];

                        setObjectClass({
                            ...objectClass,
                            file,
                        });
                    }}
                />
                <Button
                    style={{ marginRight: "15px" }}
                    color="secondary"
                    component="span"
                    variant="outlined"
                >
                    {objectClass.file || (objectClass.fileURL && objectClass.fileURL !== "") ? "Change media" : "Upload media"}
                </Button>
            </label>
            {(objectClass.file || (objectClass.fileURL && objectClass.fileURL !== "")) && (
                <>
                    <Tooltip title={"Preview"}>
                        <Button
                            size="small"
                            onClick={() => setOpenFileDialog(true)}
                            style={{
                                ...buttonsStyle,
                                marginRight: "15px",
                            }}
                        >
                            <Visibility />
                        </Button>
                    </Tooltip>

                    <PreviewDialog
                        title={"Preview"}
                        open={openFileDialog}
                        setOpen={setOpenFileDialog}
                        file={null}
                        src={
                            objectClass?.file
                                ? URL.createObjectURL(objectClass?.file)
                                : `${SERVER_URL}/${objectClass.fileURL}`
                        }
                    />


                    <Tooltip title={"Delete"}>
                        <Button size="small"
                            onClick={() => {
                                setObjectClass({
                                    ...objectClass,
                                    file: null,
                                    fileURL: ""
                                });
                            }}
                        >
                            <Delete />
                        </Button>
                    </Tooltip>
                </>
            )}
        </div>
    );
}